import React, { ChangeEventHandler } from 'react';

import './text-input.scss';

type Props = {
  label?: string;
  name: string;
  value: string;
  onChange: ChangeEventHandler<HTMLInputElement>;
  type?: 'text' | 'password';
  autoFocus?: boolean;
  disabled?: boolean;
  placeholder?: string;
  onClick?: () => void;
  numberOnly?: boolean;
  allowNegativeNumbers?: boolean;
};

const TextInput = ({
  label,
  name,
  value,
  onChange,
  type,
  autoFocus,
  disabled,
  placeholder,
  onClick,
  numberOnly,
  allowNegativeNumbers
}: Props) => {
  const handleChange: ChangeEventHandler<HTMLInputElement> = (event) => {
    if (numberOnly) {
      const pattern = allowNegativeNumbers ? /^-?\d*\.?\d*$/ : /^\d*\.?\d*$/;
      if (!pattern.test(event.target.value)) {
        return;
      }
    }

    onChange(event);
  };

  return (
    <div className="text-input">
      {label && (
        <div className="text-input__label-container">
          <label htmlFor={name}>{label}</label>
        </div>
      )}
      <input
        className="text-input__input"
        id={name}
        value={value}
        onChange={handleChange}
        type={type}
        autoFocus={autoFocus}
        disabled={disabled}
        onClick={onClick}
        autoComplete="off"
        placeholder={placeholder}
      />
    </div>
  );
};

export default TextInput;
